import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosProxy } from '../../../../api/axiosProxy/axiosProxy';

interface UpdateLicenseParams {
  licenseId: string;
  alertStatus: 'allowed' | 'review' | 'denied';
}

export const useUpdateLicense = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ licenseId, alertStatus }: UpdateLicenseParams) => {
      return await AxiosProxy.put({
        url: `license/${licenseId}`,
        body: {
          alertStatus,
        },
      });
    },
    onSuccess: () => {
      // Invalidate and refetch licenses data - match the exact query key used by useFetchLicenses
      queryClient.invalidateQueries({ queryKey: ['licenses', '/licenses'] });
    },
  });
};
